import { SerializableObject } from '../../common-react/core';

import { ShipmentType } from '../other/shipment-type.enum';

import { ShipmentDeliveryService } from './shipment-delivery-service.do';
import { ShipmentServiceBracketCustomInput } from './shipment-service-bracket-custom-input.do';
import { ShipmentServiceBracketLabel } from './shipment-service-bracket-label.do';

export class ShipmentServiceBracket extends SerializableObject {
  public imageUrl: string;
  public labels: ShipmentServiceBracketLabel[];
  public service?: ShipmentDeliveryService;
  public customInput?: ShipmentServiceBracketCustomInput;
  public order?: number;
  public type: ShipmentType;
  public weightBracket: number;
  public domesticBracket: boolean;

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    switch (propertyName) {
      case 'customInput':
        return propertyValue ? new ShipmentServiceBracketCustomInput(propertyValue) : undefined;

      case 'labels':
        if (!propertyValue || !Array.isArray(propertyValue)) {
          return [];
        }
        return propertyValue.map((value): ShipmentServiceBracketLabel => {
          return new ShipmentServiceBracketLabel(value);
        });

      case 'service':
        return propertyValue ? new ShipmentDeliveryService(propertyValue) : undefined;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }
}
